export class EntityBranchGoal {
    public c_goal_year: number | null = null;
    public c_branch_name: string | null = null;
    public c_goal_earnings_sum: number | null = null;
    public c_goal_gross_sum: number | null = null; 
}